<template>
  <div>
    <div class="ref-flow-jwt ref-flow-jwt" v-show="authConfig.loginMechanism == 'jwt'">
      <template v-for="(jwt,index) in jwtAuth">
        <div class="y-form-row y-form-row__fullwidth" :key="index">
          <template v-if="!jwt.issuerId || jwt.issuerId === ''">
            <el-row>
              <el-col :span="14">
                <label
                  class="y-form-label y-form-label__heavy is-required"
                >Setup {{index + 1}}: {{ $lang.messages.form_label_RSA_public_key }}</label>
              </el-col>
              <el-col :span="10" v-if="index > 0">
                <el-button
                  class="y-button y-warning-button y-button-small"
                  @click="deleteJwt(index)"
                >Delete JWT</el-button>
              </el-col>
            </el-row>
            <el-input
              v-model="jwt.rsaKey"
              placeholder
              type="textarea"
              :rows="4"
              class="y-form-input y-form-input__small"
              :class="errors.first('rsaDevKey'+envData+index) ? 'y-form-input-error':''"
              style="width:300px"
              data-vv-validate-on="change"
              data-vv-as="RSA public key"
              :name="'rsaKey'+envData+index"
              v-validate="{required:true, isValidRsaKey: true}"
            ></el-input>
            <span class="y-form-error errorField" v-show="errors.first('rsaKey'+envData+index)">
              <i class="el-icon-warning"></i>
              {{ errors.first('rsaKey'+envData+index )}}
            </span>
          </template>
          <template v-if="jwt.issuerId && jwt.issuerId !== ''">
            <el-row>
              <el-col :span="14">
                <label
                  class="y-form-label y-form-label__heavy is-required"
                >{{ $lang.messages.form_label_jwt_issuer_id }}</label>
              </el-col>
              <el-col :span="10">
                <el-button
                  class="y-button y-warning-button y-button-small"
                  @click="deleteJwtIssuer(jwt)"
                >Delete</el-button>
              </el-col>
            </el-row>
            <span class="y-form-inline-data">{{jwt.issuerId}}</span>
          </template>
        </div>
      </template>
      <div class="y-form-row y-form-row__fullwidth" v-if="jwtAuth.length != maxJwtCount">
        <el-link class="y-form-link" @click="addNewJwt">
          <i class="el-icon-circle-plus-outline"></i>
          {{ $lang.messages.form_link_Add_another_setup }}
        </el-link>
      </div>
    </div>
    <div class="ref-flow-saml ref-flow-saml" v-show="authConfig.loginMechanism == 'saml'">
      <div class="y-form-row y-form-row__fullwidth">
        <template v-if="!nonssoAuth.password || nonssoAuth.password == ''">
          <label
            class="y-form-label y-form-label__heavy is-required"
          >{{ $lang.messages.form_label_login_id_for_yodlee_applications }}</label>
          <el-input
            v-model="nonssoAuth.loginId"
            placeholder="Login ID"
            class="y-form-input y-form-input__small"
            :class="errors.first('nonssoLoginId'+envData) ? 'y-form-input-error':''"
            style="width:300px"
            data-vv-validate-on="change"
            data-vv-as="Login Id"
            :name="'nonssoLoginId'+envData"
            v-validate="{required: true, min: 6, max: 50, alpha_num: true, regex: '^[a-zA-Z]+[a-zA-Z0-9]*$'}"
          ></el-input>
          <span class="y-form-error errorField" v-show="errors.first('nonssoLoginId'+envData)">
            <i class="el-icon-warning"></i>
            {{ errors.first('nonssoLoginId'+envData)}}
          </span>
        </template>
        <template v-if="nonssoAuth.password && nonssoAuth.password != ''">
          <label class="y-form-label y-form-label__heavy">{{ $lang.messages.form_label_login_id }}</label>
          <el-row>
            <el-col :span="14">
              <span class="y-form-inline-data">{{nonssoAuth.loginId}}</span>
            </el-col>
            <el-col :span="10">
              <el-button
                class="y-button y-warning-button"
                :disabled="nonssoAuth.resetPassword"
                @click="resetPassword(nonssoAuth)"
              >{{ $lang.messages.form_btn_reset_password }}</el-button>
            </el-col>
          </el-row>
        </template>
      </div>
      <div class="y-form-row y-form-row__fullwidth">
        <label
          class="y-form-label y-form-label__heavy is-required"
        >{{ $lang.messages.form_label_SAML_certificate }}</label>
        <template v-if="!samlAuth.certificateId || samlAuth.certificateId == ''">
          <el-button class="y-button">
            <y-file-upload :removeHandler="()=>{}" :beforeUploadHandler="()=>{}" :fileUploadProps="certUploadData" :uploadHandler="submitUploadCert"></y-file-upload>
          </el-button>
        </template>
        <template v-if="samlAuth.certificateId && samlAuth.certificateId != ''">
          <el-tag
            closable
            type="info"
            class="y-tag"
            @close="removeCert(samlAuth)"
          >{{samlAuth.certificateId}}</el-tag>
        </template>
        <span class="y-form-error errorField" v-show="errors.first('samlCert'+envData)">
          <i class="el-icon-warning"></i>
          {{ errors.first('samlCert'+envData)}}
        </span>
      </div>
      <div class="y-form-row y-form-row__fullwidth">
        <label
          class="y-form-label y-form-label__heavy is-required"
        >{{ $lang.messages.form_label_SAML_issuer_id }}</label>
        <el-input
          v-model="samlAuth.issuerId"
          placeholder
          class="y-form-input y-form-input__small"
          :class="errors.first('samlIssuerId'+envData) ? 'y-form-input-error':''"
          style="width:300px"
          data-vv-validate-on="change"
          data-vv-as="Issuer Id"
          :name="'samlIssuerId'+envData"
          v-validate="{required: true, min: 2, max: 50}"
        ></el-input>
        <span class="y-form-error errorField" v-show="errors.first('samlIssuerId'+envData)">
          <i class="el-icon-warning"></i>
          {{ errors.first('samlIssuerId'+envData)}}
        </span>
      </div>
      <div class="y-form-row y-form-row__fullwidth">
        <label
          class="y-form-label y-form-label__heavy is-required"
        >{{ $lang.messages.form_label_SSO_post_source }}</label>
        <el-input
          v-model="samlAuth.postSource"
          placeholder
          class="y-form-input y-form-input__small"
          :class="errors.first('samlSsoPostSource'+envData) ? 'y-form-input-error':''"
          style="width:300px"
          data-vv-validate-on="change"
          data-vv-as="SSO Post Source"
          :name="'samlSsoPostSource'+envData"
          v-validate="{required: true, min: 2, max: 50}"
        ></el-input>
        <span class="y-form-error errorField" v-show="errors.first('samlSsoPostSource'+envData)">
          <i class="el-icon-warning"></i>
          {{ errors.first('samlSsoPostSource'+envData)}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import serviceRegistery from '../../mixins/serviceRegistery'
import yFileUploadPopup from '../../components/yFileUploadPopup'
import Vue from 'vue'
import Vuex from 'vuex'
import { mapActions } from 'vuex'
Vue.use(Vuex)
export default {
  name: 'SetupLoginForm',
  inject: ['$validator'],
  components: { 'y-file-upload': yFileUploadPopup },
  props: {
    loginFormProps: Object,
    envProp: String
  },
  data() {
    return {
      loginFormData: this.loginFormProps,
      envData: this.envProp,
      maxJwtCount: 2,
      newJwt: {
        algorithm: 'RS512',
        expTime: '',
        rsaKey: ''
      },
      certUploadDefaultData: {
        displayName: '',
        displayLinkName: this.$lang.messages.form_btn_upload_cer_file,
        defaultValue: '',
        authData: {},
        env: '',
        popupProps: {
          type: 'CERT',
          customClasses: 'popup-class',
          showPopup: false,
          accept: '.cer',
          isValid: true,
          errorMessage: '',
          buttonName: 'Upload',
          isInfo: true,
          infoMessage: ''
        }
      }
    }
  },
  created() {},
  computed: {
    setupTemplateData() {
      return this.$store.state.createSubbrandStore.setupTemplateData
    },
    authConfig() {
      let authConfig = this.setupTemplateData.config.authConfig
      return authConfig
    },

    jwtAuth() {
      let jwtAuth = []
      if (this.loginFormData && this.loginFormData.jwt) {
        jwtAuth = this.loginFormData.jwt
      }
      return jwtAuth
    },

    nonssoAuth() {
      let nonssoAuth = {}
      if (this.loginFormData && this.loginFormData.nonsso[0]) {
        nonssoAuth = this.loginFormData.nonsso[0]
      }
      return nonssoAuth
    },

    samlAuth() {
      let samlAuth = {}
      if (this.loginFormData && this.loginFormData.saml[0]) {
        samlAuth = this.loginFormData.saml[0]
      }
      return samlAuth
    },
    certUploadData() {
      var certUploadData = JSON.parse(
        JSON.stringify(this.certUploadDefaultData)
      )
      certUploadData.env = this.envData
      certUploadData.authData = this.samlAuth
      return certUploadData
    }
  },
  methods: {
    ...mapActions([]),
    addNewJwt() {
      this.jwtAuth.push(this.newJwt)
    },

    deleteJwt(index) {
      this.jwtAuth.splice(index, 1)
    },

    resetPassword(nonssoObj) {
      console.log(nonssoObj)
      nonssoObj.resetPassword = true
    },

    deleteJwtIssuer(jwtData) {
      console.log(jwtData)
      jwtData.issuerId = ''
    },

    removeCert(certData) {
      certData.certificateId = ''
    },

    submitUploadCert(scope, files, componentArg) {
      console.log('upload Cert', scope, files, componentArg)
      let fileList = files
      let component = componentArg
      var self = this
      let ext
      if (fileList.length <= 0) {
        component.popupProps.isValid = false
        component.popupProps.errorMessage = 'Please select the file'
      } else if (/\.(cert|cer)$/i.test(fileList[0].name) === false) {
        component.popupProps.isValid = false
        component.popupProps.errorMessage =
          'Please select the correct certificate file(.cert or .cer)'
      } else {
        if (!fileList.length) return
        const formdata = new FormData()
        // append the files to FormData
        Array.from(Array(fileList.length).keys()).map(x => {
          fileList[x].name = fileList[x].name
          formdata.append('resource', fileList[x].raw, fileList[x].name)
          ext = fileList[x].name.split('.').pop()
          formdata.append('format', ext)
        })
        formdata.append(
          'cobrand',
          this.$store.state.appStore.selectedSubbrandInfo._id
        )
        formdata.append('type', 'SAML_CERT')
        formdata.append('environment', component.env)
        serviceRegistery
          .makeCall({
            url: this.$hostname + 'services/resource/upload',
            method: 'PUT',
            data: formdata,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            console.log('Certificate uploaded')
            if (component.env && component.env == 'DEVELOPMENT') {
              self.$store.state.createSubbrandStore.setupTemplateData.config.authConfig.development.auths.saml[0].certificateId =
                response.data.fileName
            } else if (component.env && component.env == 'PRODUCTION') {
              self.$store.state.createSubbrandStore.setupTemplateData.config.authConfig.production.auths.saml[0].certificateId =
                response.data.fileName
            }
            console.log(
              'AUTH DATA--->',
              self.$store.state.createSubbrandStore.setupTemplateData.config
                .authConfig
            )
          })
          .catch(() => {
            console.log('Certificate upload failed')
            self.showToastMessage(
              'Sorry, a technical error has occurred! Please try again later.'
            )
          })
      }
      // let samlCert = samlCertObj

      // if (samlCert.defaultValue && !$('#files')[0].files[0]) {
      //   //this.continueStep()
      // } else if (
      //   /\.(cert|cer)$/i.test($('#files')[0].files[0].name) === false
      // ) {
      //   this.isSamlCertinError = true
      //   samlCert.showError = true
      //   samlCert.errorMessage =
      //     'Please select the correct format(.cert or .cer).'
      //   //this.continueStep()
      // } else if ($('#files')[0].files[0]) {
      //   let formdata = new FormData()

      //   formdata.append('resource', $('#files')[0].files[0])
      //   formdata.append(
      //     'cobrand',
      //     this.$store.state.appStore.selectedSubbrandInfo._id
      //   )
      //   formdata.append('type', 'SAML_CERT')
      //   formdata.append('environment', env)

      //   serviceRegistery
      //     .makeCall({
      //       url: this.$hostname + 'services/resource/upload',
      //       method: 'PUT',
      //       data: formdata,
      //       headers: {
      //         'Content-Type': 'multipart/form-data'
      //       }
      //     })
      //     .then(response => {
      //       samlCert.showError = false
      //       samlCert.errorMessage = ''
      //       samlCert.defaultValue = response.data.fileName
      //       samlCert.certId = response.data._id
      //       this.continueStep()
      //     })
      //     .catch(() => {
      //       console.log('Certificate upload failed')
      //       this.showToastMessage(
      //         'Sorry, a technical error has occurred! Please try again later.'
      //       )
      //     })
      // } else {
      //   samlCert.showError = false
      //   samlCert.showError = true
      //   samlCert.errorMessage = 'Required field.'
      //   console.log('Certificate not selected')
      // }
    }
  }
}
</script>

<style>
</style>
